import {
    ButtonSubmit,
    ColourSolid,
    ComboBoxControl,
    FlexGap,
    Modal,
    ModalType, SelectItemType,
    StackVertical,
    UploadFile
} from "@twigsby/frontend-framework";
import {Controller, FieldValues, FormProvider, useForm} from "@twigsby/frontend-framework/lib/ReactHookForm";
import React, {useEffect} from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";

const AddDocumentToBatchModal = (props: ModalType) => {
    const { uploadingShippingDocument, AddDocumentToBatch, GetUserDocumentTypes, userDocumentTypes } = useForwardingBatchProvider();

    const formMethods = useForm({
        defaultValues: {
            file: null,
            documentType: -1,
        }
    });

    const HandleAttachDocument = (data: FieldValues) => {
        const file = formMethods.getValues('file');

        if(file) {
            AddDocumentToBatch(file, formMethods.getValues('documentType'), props.closeCallback);
        }
    }

    useEffect(() => {
        formMethods.reset();
        if(props.isOpen) {
            GetUserDocumentTypes();
        }
    }, [props.isOpen]);

    return (
        <Modal
            title={'Attach Document'}
            isOpen={props.isOpen}
            closeCallback={props.closeCallback}
        >
            <FormProvider {...formMethods}>
                <form onSubmit={formMethods.handleSubmit((data: FieldValues) =>  HandleAttachDocument(data))}>
                    <fieldset>
                        <StackVertical gap={FlexGap.Medium}>
                            <Controller
                                control={formMethods.control}
                                name='documentType'
                                rules={{ required: 'A file is required', min: 0 }}
                                render={({field}) =>
                                    <ComboBoxControl
                                        loading={!userDocumentTypes}
                                        data={userDocumentTypes?.documentTypes as Array<SelectItemType>}
                                        valueType={'string'}
                                        name={'documentType'}
                                        forwardValueCallback={(e) => field.onChange(e)}
                                        placeholder={'Select Document Type...'}
                                        singleSelection={true}
                                        reset={props.isOpen}
                                    />
                                }
                            />

                            <Controller
                                control={formMethods.control}
                                name='file'
                                rules={{ required: 'A file is required' }}
                                render={({field}) =>
                                    <UploadFile
                                        onChange={(e: any) => field.onChange(e)}
                                        accept={'.pdf'}
                                        extensionDisplayValue={'PDF'}
                                        singleFileOnly={true}
                                        reset={props.isOpen}
                                    />
                                }
                            />

                            <ButtonSubmit
                                loading={uploadingShippingDocument}
                                disabled={uploadingShippingDocument || !formMethods.formState.isValid}
                                colour={ColourSolid.Primary}
                                fullWidth={true}
                                title={'Upload'}
                            />

                        </StackVertical>

                    </fieldset>
                </form>
            </FormProvider>
        </Modal>
    )
}

export { AddDocumentToBatchModal }
